module.exports = __webpack_public_path__ + "static/media/zoomIn.49e1dabc.svg";